import {DateTime, Format} from '@cabinetsbycomputer/datetime';

// a job's requested delivery date, which includes a time, as the date only
// value the delivery date picker and forms work with
export const toFormDate = (date?: string | null) =>
    date
        ? DateTime.parseCustom(date, Format.DateTime)
              .format(Format.Date)
              .toString()
        : undefined;
